import React from 'react';

import { api } from '../../../api';
import { isImageUrl } from '../../../util/url';

const GlobalInfobar = () => {
  const { data: personalizationContent, isLoading: personalizationContentLoading } =
    api.personalization.personalizationContent.useQuery();

  if (
    personalizationContentLoading ||
    !personalizationContent?.infobar?.enabled ||
    !personalizationContent.infobar.message?.trim()
  ) {
    return null;
  }

  const iconUrl = personalizationContent.infobar.iconUrl?.trim();
  const showIcon = Boolean(iconUrl && isImageUrl(iconUrl));

  return (
    <div className="w-full bg-yellow-2" aria-label="Banner" role="banner">
      <div className="container mx-auto flex flex-col px-2 py-4 md:flex-row md:items-center lg:px-0">
        <div className="flex items-start md:items-center">
          {showIcon ? <img className="message-icon mr-2 h-6 w-6 shrink-0" src={iconUrl} alt="" /> : null}
          <p className="font-bold">{personalizationContent.infobar.message}</p>
        </div>
      </div>
    </div>
  );
};

export default GlobalInfobar;
